export enum PlpPageType {
	Catalog = 'c',
	Inspirational = 'i',
}
